import { render } from "./pageLoading.vue?vue&type=template&id=57e77cfe&ts=true"
import script from "./pageLoading.vue?vue&type=script&lang=tsx"
export * from "./pageLoading.vue?vue&type=script&lang=tsx"

import "./pageLoading.vue?vue&type=style&index=0&id=57e77cfe&lang=less"

import exportComponent from "E:\\qihe\\ly-visitor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__